import MsWellDoneScreen from "../../components/MsWellDoneScreen/MsWellDoneScreen";
import { useParams } from "react-router";
function MsWellDonePage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;

  return (
    <>
      <div className={theme} data-testid="theme-name">
        <MsWellDoneScreen />
      </div>
    </>
  );
}

export default MsWellDonePage;
